import { render, staticRenderFns } from "./SubmitAppSvg.vue?vue&type=template&id=47cdaa1e"
import script from "./SubmitAppSvg.vue?vue&type=script&lang=js"
export * from "./SubmitAppSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports